const appTitle = "张掖祁连山生态环境遥感监测平台";

// 登录
const loginConfig = {
  backgroundImage: "assets/images/login/bg.png",
  mainBgImg: "assets/images/login_bg.png",
  // loginUrl: "http://210.77.77.237:8088/home/login",
  // http://210.77.77.237:8083/
  loginUrl: "http://210.72.81.165:8002/dm/login",
  loginAUrl: "http://210.77.77.237:8061/Logon",
  mainLogoImg: "assets/images/layout/title.png",
  loginFormTitle: "甘肃祁连山生态环境监测与动态评估系统"
};


const homeConfig = {
  getNouncesUrl: "http://61.178.178.131:8505/PollutionDataAnalyze/GetAlarmData",
  newsUrl: "http://210.77.77.237:8061/api/Bulletin/GetDynamic?type=公告",
  dataNewsUrl: "http://210.77.77.237:8061/api/Bulletin/GetNotice?type=动态"
}


const cartConfig = {
  //购物车以及下载操作
  addCartUrl: "http://210.72.81.165:8002/dm/m/us/cart/usrCartVo/addCart", //添加购物车接口接口
  AllCartUrl: "http://210.72.81.165:8002/dm/m/us/cart/usrCartVo/showCart", //展示购物车接口接口
  deleteCartUrl: "http://210.72.81.165:8002/dm/m/us/cart/usrCartVo/deleteByIds", //删除购物车接口接口
  addOrderUrl: "http://210.72.81.165:8002/dm/m/us/order/showOrder", //添加订单接口接口
  AllOrderUrl: "http://210.72.81.165:8002/dm/m/us/order/findUserOrder", //展示订单接口接口
  deleteOrderUrl: "http://210.72.81.165:8002/dm/m/us/order/deleteOrderIds", //删除订单接口接口
  cartImgUrl: "http://210.72.81.165:8002/dm/dataAttr/image", //获取购物车图片的接口
  mapDetailUrl: "http://210.72.81.165:8002/dm/dataAttr/selectByDataid", //地图详情接口接口
  isExistOrderUrl: "", //添加订单前判断是否存在接口
  mayEyeUrl: "http://210.72.81.165:8002/dm/dataAttr/selectByIdFindEye", //修改眼睛参数
  mapEyeAllUrl: "http://210.72.81.165:8002/dm/dataAttr/selectByFindEye"
};
const news = {
  listType: 'http://210.72.81.165:8002/dynamic/listType',
  getImg: 'http://210.72.81.165:8002/picture/listid',
  getCarousel: 'http://210.72.81.165:8002/dynamic/listPicture',
  download: 'http://210.72.81.165:8002/dynamic/getUrlById',
  listPicture:'http://210.72.81.165:8002/dynamic/listPicture'


}

export {
  appTitle,
  loginConfig,
  homeConfig,
  cartConfig,
  news
};
